import { render, staticRenderFns } from "./Epub.vue?vue&type=template&id=58b313ba&scoped=true"
import script from "./Epub.vue?vue&type=script&lang=ts"
export * from "./Epub.vue?vue&type=script&lang=ts"
import style0 from "./Epub.vue?vue&type=style&index=0&id=58b313ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b313ba",
  null
  
)

export default component.exports